// extracted by mini-css-extract-plugin
export default {"Body":"BJ59kDOo"};